export default __webpack_public_path__ + "static/media/auth-cover.70dbd530.png";